<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <tanitimMail ref="tanitimdialog" :servisTipi="2"></tanitimMail>
    <loadingcomp ref="loadingcomp" v-bind:mesaj="loadingmesaj" v-model="loadingdialog"></loadingcomp>

    <div style="background:#f0f2f5;min-height:100vh;">
      <div style="max-width:95%;margin:0 auto;padding:16px;">
        <div class="page-header-card">
          <div>
            <div style="font-size:22px;font-weight:600;">Transfer</div>
          </div>
          <v-tooltip bottom>
            <v-btn slot="activator" @click="tedarikcidialogac()" flat style="background:rgba(255,255,255,0.2);color:#fff;">
              <v-icon left dark>add_box</v-icon>
              <span class="hidden-sm-and-down">{{ $t('Supplier-Info') }}</span>
            </v-btn>
          </v-tooltip>
        </div>

        <v-dialog v-model="dialogtedarikciGuncelle" persistent max-width="800">
          <v-toolbar color="info">
            <v-toolbar-title class="white-text">
              <span class="white--text">{{ $t('Edit-Supplier') }}</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-card color="white">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="guncellenecekTedarikci.ad" label="Tedarikçi" :readonly="true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="guncellenecekTedarikci.username" label="Kullanıcı"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="guncellenecekTedarikci.password" :label="$t('Password')"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="guncellenecekTedarikci.securityKey" :label="$t('Security-Key')"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <v-text-field v-model="guncellenecekTedarikci.url" :label="$t('Service-Address')"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete ref="acenteAutoGuncelle" hide-details clearable :items="itemsSaticilar"
                    v-model="prmPaxDriveAcenteKod" :label="$t('Agency-Code-Select')" item-text="Isim"
                    item-value="Kod"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" @click="providerGuncelle()" dark>Güncelle</v-btn>
              <v-btn @click="dialogtedarikciGuncelle = false" color="info">{{ $t('Close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogtedarikci" persistent max-width="1200">
          <v-toolbar color="info">
            <v-toolbar-title class="white-text">
              <span class="white--text">{{ $t('Supplier') }}</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-card color="white">
            <v-card-text>
              <v-form ref="formgunluksatis" lazy-validation>
                <v-card flat class="pa-3">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                      <v-select :items="tedarikciItems" v-model="seciliTedarikci" label="Tedarikçi" item-text="urunAdi"
                        item-value="id" return-object></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="tedarikci.username" label="Kullanıcı"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="tedarikci.password" :label="$t('Password')"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field v-model="tedarikci.securityKey" :label="$t('Security-Key')"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md9>
                      <v-text-field v-model="tedarikci.url" :label="$t('Service-Address')"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 class="text-md-right">
                      <v-btn color="info" @click="providerEkle()" dark>
                        <span>{{ $t('Add') }}</span>
                        <v-icon right dark>add_box</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-form>

              <v-container fluid grid-list-sm>
                <v-data-table :rows-per-page-items="[100]" :headers="headerstedarikci" :items="itemsproviders">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td class="text-xs-left">{{ props.item.Provider }}</td>
                      <td class="text-xs-left">{{ props.item.ServiceUsername }}</td>
                      <td class="text-xs-left">{{ props.item.ServicePassword }}</td>
                      <td class="text-xs-left">{{ props.item.ServiceSecurityKey }}</td>
                      <td class="text-xs-left">{{ props.item.url }}</td>
                      <td class="text-xs-right">
                        <v-btn color="info" @click="providerGuncelleAc(props.item)" fab small>
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogtedarikci = false" outline color="info">{{ $t('Close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <hotelloadingcomp ref="hotelloadingcomp" iconname="rv_hookup" :mesaj="$t('Searching-Vehicles')"
          v-model="hotelloadingdialog">
        </hotelloadingcomp>

        <div class="section-card">
          <div class="card-header purple-bar">
            <div style="display:flex;align-items:center;gap:8px;">
              <v-icon color="#667eea">search</v-icon>
              <span style="font-size:15px;font-weight:600;color:#1f2937;">Transfer Ara</span>
            </div>
          </div>
          <div class="card-body">
            <v-form ref="TransferFiyatGetir" v-model="validform" lazy-validation>
                      <v-layout row wrap>
                        <v-flex pl-1 pt-2 xs12 sm6 md3>
                          <v-autocomplete @change="aramakontrol()" clearable v-model="GetVehicles.PickupPointId"
                            :items="transferaditems" :label="$t('Boarding-Place')" append-icon="search" item-text="name"
                            item-value="value" hide-details :rules="[(v) => !!v || $t('Mandatory-section')]"
                            :search-input.sync="search" :filter="customFilter">
                            <template slot="item" slot-scope="data">
                              <v-icon small color="grey" class="mr-2" v-if="data.item.LocType == 2">flight</v-icon>
                              <v-icon small color="grey" class="mr-2" v-else-if="data.item.LocType == 3">domain</v-icon>
                              <v-icon small color="grey" class="mr-2"
                                v-else-if="data.item.LocType == 1">location_on</v-icon>
                              <v-icon small color="grey" class="mr-2" v-else>place</v-icon> <span id="PickupName">{{
                                data.item.name }}</span>
                            </template>
                          </v-autocomplete>
                        </v-flex>

                        <v-flex pl-1 pt-2 xs12 sm6 md3>
                          <v-autocomplete :items="transferbirakaditems" @change="aramakontrolBirak()"
                            v-model="GetVehicles.DropPointId" :label="$t('Departure-Place')" item-text="name"
                            item-value="value" append-icon="search" hide-details clearable
                            :rules="[(v) => !!v || $t('Mandatory-section')]" :search-input.sync="search2" :filter="customFilter">
                            <template slot="item" slot-scope="data">
                              <v-icon small color="grey" class="mr-2" v-if="data.item.LocType == 2">flight</v-icon>
                              <v-icon small color="grey" class="mr-2" v-else-if="data.item.LocType == 3">domain</v-icon>
                              <v-icon small color="grey" class="mr-2"
                                v-else-if="data.item.LocType == 1">location_on</v-icon>
                              <v-icon small color="grey" class="mr-2" v-else>place</v-icon> <span id="DropName">{{
                                data.item.name }}</span>
                            </template>
                          </v-autocomplete>
                        </v-flex>

                        <v-flex pl-1 pt-2 xs6 sm4 md2>
                          <tarihim :etiket="$t('Date')" :detaygizle="false" v-model="GetVehicles.TransferDateAndTime"
                            :rules="[(v) => !!v || $t('Mandatory-section')]" :min="minTransferDate"></tarihim>
                        </v-flex>

                        <v-flex pl-1 pt-2 xs6 sm4 md1>
                          <v-text-field :label="$t('Hour-Label')" hide-details :rules="[(v) => !!v || $t('Mandatory-section')]"
                            v-model="Time" type="time"></v-text-field>
                        </v-flex>

                        <v-flex pt-3 xs12 md3>
                          <v-menu bottom :close-on-content-click="false" offset-y style="width: 100%;">
                            <v-btn slot="activator" block outline class="ma-0"
                              style="height: 40px; border:none; border-bottom:1px solid gray">
                              <v-icon color="info">supervisor_account</v-icon>
                              <span class="ml-2">
                                ({{ yetiskinSayi }} {{ $t("Adult") }}
                                {{ cocukSayi }} {{ $t("Child") }}
                                {{ bebekSayi }} {{ $t("Baby") }})
                              </span>
                            </v-btn>
                            <v-list>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-btn outline fab small @click="yetiskinAzalt" :disabled="!!Azalt" color="primary">
                                    <v-icon>remove</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ yetiskinSayi }} {{ $t("Adult") }}</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-btn outline fab small @click="yetiskinArttir" color="primary">
                                    <v-icon>add_box</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-btn outline fab small @click="cocukAzalt" :disabled="!!AzaltCocuk" color="primary">
                                    <v-icon>remove</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ cocukSayi }} {{ $t("Child") }}</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-btn outline fab small @click="cocukArttir" color="primary">
                                    <v-icon>add_box</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-btn outline fab small @click="bebekAzalt" :disabled="!!AzaltBebek" color="primary">
                                    <v-icon>remove</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ bebekSayi }} {{ $t("Baby") }}</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-btn outline fab small @click="bebekArttir" color="primary">
                                    <v-icon>add_box</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </v-flex>

                        <v-flex pl-1 pt-2 xs12 sm4 md3>
                          <parainputevents :rules="[(v) => !!v || $t('Mandatory-section')]"
                            v-if="GetVehicles.MarkupType == 'PC-1'" v-model="GetVehicles.Markup"
                            :simge="getparabirimi()" :etiket="$t('Markup-Amount')" :autocomplete="'autocomplete'">
                          </parainputevents>

                          <yuzdeinput v-if="GetVehicles.MarkupType == 'PT'"
                            :rules="[(v) => !!v || $t('Mandatory-section')]" :etiket="$t('Markup-Percentage')"
                            v-model="GetVehicles.Markup">
                          </yuzdeinput>
                        </v-flex>

                        <v-flex pl-1 pt-2 xs12 sm3 md3>
                          <v-select :label="$t('Markup-Unit')" v-model="GetVehicles.MarkupCurrency" :items="kuritems"
                            item-text="text" item-value="value"></v-select>
                        </v-flex>

                        <v-flex pl-1 pt-2 xs12 sm4 md3>
                          <v-select :label="$t('Markup-Type')" v-model="GetVehicles.MarkupType" :items="markupitems"
                            item-text="text" item-value="value"></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 md3 class="pl-8 pt-4">
                          <v-layout align-center justify-end fill-height>
                            <v-btn color="info" outline style="height: 40px; width: 50%;" @click="TransferAra()">
                              Transfer Ara
                            </v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
            </v-form>
          </div>
        </div>

        <div v-if="kayitvarmi" style="width:100%;">
          <div class="section-card" style="margin-bottom:8px;">
            <div style="padding:12px 16px;">
              <span style="font-size:14px;font-weight:600;color:#1f2937;">{{ transferitems.length }} {{ this.$t('Number-of-Records-Found') }}</span>
            </div>
          </div>

          <div v-for="item in transferitems" :key="item.Id" style="margin-bottom:12px;width:100%;">
            <v-hover>
              <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" style="border-radius:16px;width:100%;" >
                  <v-card-actions class="pa-3">
                    <v-layout row wrap align-center>
                      <v-flex xs12 sm4 md2>
                        <div class="transfer-img-frame">
                          <img :src="getImgUrl(item.PhotoPath)"
                            style="width: 100%; max-width: 160px; max-height: 120px; object-fit: contain; display: block; margin: auto;" />
                        </div>
                      </v-flex>

                      <v-flex xs12 sm8 md4 pl-3>
                        <v-layout column>
                          <v-flex>
                            <span class="font-weight-black subheading">{{ item.Title }}</span>
                            <v-icon color="red" small class="mx-1">clear</v-icon>
                            <span class="font-weight-bold red--text">{{ item.VehicleCount }}</span>
                          </v-flex>
                          <v-flex pt-2>
                            <v-layout row wrap align-center>
                              <span class="red--text mr-3">
                                <v-icon color="grey" small>alarm</v-icon> {{ item.TransferDateAndTime | dateformat }}
                              </span>
                              <span class="mr-3">
                                <v-icon color="grey" small>people_outline</v-icon> {{ item.MaxPax }} {{ $t("Passenger")
                                }}
                              </span>
                              <span>
                                <v-icon color="grey" small>work_outline</v-icon> {{ item.MaxSuitcase }}
                              </span>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                                

                      <v-flex xs12 sm6 md4 pl-3>
                        <v-layout column>
                          <v-flex class="mb-1">
                            <v-icon small color="green">check</v-icon>
                            <span class="grey--text body-1 ml-1">{{ $t("Cancellation-until-last-hours", {
                              value:
                                item.FreeCancelHourBefore
                            }) }}</span>
                          </v-flex>
                          <v-flex>
                            <v-icon small color="green">check</v-icon>
                            <span class="grey--text body-1 ml-1">{{ $t("Change-until-hours", {
                              value:
                                item.FreeChangeHourBefore
                            }) }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm6 md2 class="text-xs-right">
                        <v-layout column align-end justify-center>
                          <v-flex>
                            <div class="red--text title font-weight-bold">
                              {{ item.PriceDetails.UserPrice | moneyformat }} {{ item.Rate }}
                            </div>
                          </v-flex>
                          <v-flex pt-2>
                            <v-btn outline @click="idgonder(item.ProductId, item.ResponseId, item.Rate)" color="green"
                              class="ma-0">
                              <span class="subtitle-2 green--text">{{ $t("Select") }}</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </div>
        </div>

        <div v-if="!kayitvarmi" class="section-card" style="margin-top:20px;">
            <v-layout row wrap align-center justify-center>
              <v-flex xs12 class="text-xs-center mb-3">
                <blockquote class="blockquote">
                  {{ $t("runner-v8") }}
                  <v-btn color="blue-grey" class="white--text ml-3" @click="irtibatDialog()">
                    {{ $t("CONTACT-US") }} <v-icon right dark>contact_mail</v-icon>
                  </v-btn>
                </blockquote>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <img class="responsive" src="../../../../assets/images/paxDrive.jpeg" />
              </v-flex>
            </v-layout>
        </div>
      </div>
    </div>

    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">{{ $t("Close") }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import auth from "@/api/auth.js";
import _ from "underscore";
import router from "@/router.js";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import parainputevents from "@/components/app/customcomp/parainputevents";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput";
import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp.vue";
import tool from "../../coper/tools";

export default {
  components: {
    tarihim,
    parainputevents,
    yuzdeinput,
    hotelloadingcomp,
    tanitimMail,
    yetkidialog,
    loadingcomp
  },
  props: {
    source: String,
  },
  data() {
    return {
      Otel: {
        saticiTipi: 1,
        saticiKodu: null,
        sqlLike: null,
        limit: null
      },
      itemsSaticilar: [],
      prmPaxDriveAcenteKod: null,
      minTransferDate: this.getMinTransferDate(),
      rules: {
        required: (value) => !!value || this.$t("Mandatory-Areas"),
      },
      guncellenecekTedarikci: {
        ad: '',
        id: 0,
        username: '',
        password: '',
        url: '',
        securityKey: ''
      },
      firmaBilgileri: null,
      bookingUserName: '',
      bookingUserPassword: '',
      itemsproviders: [],
      headerstedarikci: [
        { text: this.$t('Provider-Label') },
        { text: this.$t('User') },
        { text: this.$t('Password') },
        { text: this.$t('Security-Key') },
        { text: "URL" },
        { text: this.$t('Edit') },
      ],
      tedarikciItems: [
        { urunAdi: 'Paxdrive', id: 0 }
      ],
      seciliGuncelleTedarikci: null,
      seciliTedarikci: null,
      tedarikci: {
        ad: '',
        id: 0,
        username: '',
        password: '',
        url: '',
        securityKey: ''
      },
      dialogtedarikciGuncelle: false,
      dialogtedarikci: false,
      yetkidialog: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      SessionId: '',
      SessionToken: '',
      pagenumber: 1,
      sayfalama: 1,
      paginationDisabled: false,
      vmodelpagination: false,
      islemTipi: null,
      loadingmesaj: null,
      loadingdialog: false,
      hotelloadingdialog:false,
      validform: true,
      progress: true,
      Time: "",
      search: "",
      search2: "",
      Azalt: false,
      AzaltCocuk: true,
      AzaltBebek: true,
      menu: false,
      yetiskinSayi: 1,
      cocukSayi: 0,
      bebekSayi: 0,
      transferaditems: [],
      transferbirakaditems: [],
      alinisitems: [],
      birakilisitems: [],
      transferitems: [],
      markupitems: [
        { text: this.$t("Percentage"), value: "PT" },
        { text: this.$t("Amount"), value: "PC-1" },
      ],
      GetVehicles: {
        PickupPoint: null,
        DropPoint: null,
        PickupPointId: null,
        DropPointId: null,
        TransferDateAndTime: this.getMinTransferDate(),
        AdtPaxCount: null,
        ChdPaxCount: null,
        InfPaxCount: null,
        TransferType: null,
        MarkupType: "PC-1",
        Markup: 0,
        MarkupCurrency: "TRY",
      },
      LocationInput: {
        Text: null,
        Id: 0,
      },
      siralamatipiitems: [
        { text: this.$t("Price-Ascending"), value: "Price" },
        { text: this.$t("Price-Descending"), value: "PriceDesc" },
      ],
      kuritems: [
        { text: "TRY", value: "TRY" },
        { text: "EUR", value: "EUR" },
        { text: "USD", value: "USD" },
        { text: "GBP", value: "GBP" },
      ],
      aramaYapildimi: false,
      aramaYapildimiBirak: false,
      kayitvarmi: false,
      kayitsayi: 0,
      clipped: true,
      drawer: true,
      fixed: false,
      right: true,
      dialog: false,
      loginstatus: true,
      text1: "",
      snackbar: false,
      loading: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      confirm: null,
      Credential: {
        email: "",
        password: "",
      },
      valid: true,
    };
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.BookingKontrol();
      this.getTransferSaticilar();

      if (this.$route.query.islemTipi != undefined && this.$route.query.islemTipi != null) {
        if (this.$route.query.islemTipi == "pdget") {
          this.islemTipi = "pdget";
        } else {
          this.islemTipi = "pdyeni";
        }
      } else {
        this.islemTipi = "pdyeni";
      }

      if (this.islemTipi == "pdget") {
        var pdtransfer = JSON.parse(window.localStorage.getItem("pdtransfer"));
        if (pdtransfer != null) {
          this.yetiskinSayi = 0;
          this.cocukSayi = 0;
          this.bebekSayi = 0;

          pdtransfer.Rezervasyon.adresler.forEach((element) => {
            if (element.kisiTip == 1) {
              this.cocukSayi = this.cocukSayi + 1;
              this.AzaltCocuk = false;
            } else if (element.kisiTip == 2) {
              this.bebekSayi = this.bebekSayi + 1;
              this.AzaltBebek = false;
            } else {
              this.yetiskinSayi = this.yetiskinSayi + 1;
            }
          });
        } else {
          this.text1 = this.$t("Wrong-process-will-conducted-newpnr-record-continue");
          this.snackbar = true;
          this.islemTipi = "pdyeni";
        }
      }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  beforeMount() { },
  watch: {
    search(val) {
      if (this.aramaYapildimi == false) {
        val && this.AlinisYeriCek(val);
      } else {
        this.aramaYapildimi = false;
      }
    },
    search2(val) {
      if (this.aramaYapildimiBirak == false) {
        val && this.BirakilisYeriCek(val);
      } else {
        this.aramaYapildimiBirak = false;
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const text = item.name.toLowerCase();
      const query = queryText.toLowerCase();
      return text.includes(query); // Sadece arama sonucunu döner, sıralamaya müdahale etmez.
    },
    getTransferSaticilar() {
      this.Otel.saticiTipi = 2;
      this.Otel.saticiKodu = null;
      this.Otel.sqlLike = '';
      this.Otel.limit = 0;

      var prm = this.Otel;

      tool.http_post(this, "SaticiList", prm).then(
        response => {
          if (response.body.Status == true) {
            if (response.body.SaticiList.length > 0) {
              this.itemsSaticilar = response.body.SaticiList;
            } else {
              this.itemsSaticilar = [];
            }
          } else {
            this.text1 = 'Service Unavailable';
            this.snackbar = true;
          }
        },
        response => {
          this.text1 = 'Service Unavailable';
          this.snackbar = true;
        }
      );
    },
    providerGuncelleAc(val) {
      this.guncellenecekTedarikci.ad = val.Provider;
      this.guncellenecekTedarikci.id = val.Id;
      this.guncellenecekTedarikci.username = val.ServiceUsername;
      try {
        this.guncellenecekTedarikci.url = val.url;
      } catch { }
      this.guncellenecekTedarikci.password = val.ServicePassword;
      this.guncellenecekTedarikci.securityKey = val.ServiceSecurityKey;
      this.dialogtedarikciGuncelle = true;
    },
    providerGuncelle() {
      var params = {
        SessionHeader: {
          SessionId: this.SessionId,
          SessionToken: this.SessionToken
        },
        isTest: false,
        isActive: true,
        Provider: this.guncellenecekTedarikci.ad,
        ProviderType: 'Transfer',
        ServiceUsername: this.guncellenecekTedarikci.username,
        ServicePassword: this.guncellenecekTedarikci.password,
        ServiceSecurityKey: this.guncellenecekTedarikci.securityKey,
        Address: this.guncellenecekTedarikci.url,
        OfficeId: this.prmPaxDriveAcenteKod
      };
      this.$http
        .post(auth.BOOKING_API_URL + "Agency/EditCredential", params, {
          headers: { Authorization: "Bearer " + auth.getAuthHeader() },
        })
        .then(
          (response) => {
            if (response.body.HasError == false) {
              this.getProviders();
              this.dialogtedarikciGuncelle = false;
            }
          },
          (response) => {
            this.text1 = this.$t('Service-Unavailable');
            this.loadingdialog = false;
            this.snackbar = true;
          }
        );
    },
    providerEkle() {
      var params = {
        SessionHeader: {
          SessionId: this.SessionId,
          SessionToken: this.SessionToken
        },
        Provider: this.seciliTedarikci.urunAdi,
        ProviderType: 'Transfer',
        ServiceUsername: this.tedarikci.username,
        ServicePassword: this.tedarikci.password,
        ServiceSecurityKey: this.tedarikci.securityKey,
        Address: this.tedarikci.url
      };
      this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddCredential", params, {
          headers: { Authorization: "Bearer " + auth.getAuthHeader() },
        })
        .then(
          (response) => {
            if (response.body.HasError == false) {
              this.getProviders();
              this.seciliTedarikci = null;
              this.tedarikci.username = '';
              this.tedarikci.password = '';
              this.tedarikci.securityKey = '';
              this.tedarikci.url = '';
            }
          },
          (response) => {
            this.text1 = this.$t('Service-Unavailable');
            this.loadingdialog = false;
            this.snackbar = true;
          }
        );
    },
    tedarikcidialogac() {
      this.getProviders();
      this.dialogtedarikci = true;
    },
    async addAgency2() {
      this.loadingdialog = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        Name: credentials.CoperSirketAdi,
        City: this.firmaBilgileri.City,
        District: this.firmaBilgileri.District,
        CountryCode: "TR",
        Address: this.firmaBilgileri.Address,
        Gsm: this.firmaBilgileri.Gsm,
        Email: this.firmaBilgileri.Email,
        TaxOffice: this.firmaBilgileri.TaxOffice,
        TaxNo: this.firmaBilgileri.TaxNo
      };

      this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddAgency", params, {
          headers: { Authorization: "Bearer " + auth.getAuthHeader() },
        })
        .then(
          (response) => {
            if (response.body.Usernanme != null) {
              this.bookingUserName = response.body.Username;
              this.bookingUserPassword = response.body.Password;
            }
            this.loadingdialog = false;
          },
          (response) => {
            this.text1 = this.$t('Service-Unavailable');
            this.loadingdialog = false;
            this.snackbar = true;
            return false;
          }
        );
      this.loadingdialog = false;
      return true;
    },
    async FirmaBilgileriGetir() {
      this.loadingdialog = true;
      try {
        const credentials = JSON.parse(window.localStorage.getItem("credentials"));
        const paramscompany = { SirketKodu: credentials.SirketKodu };
        const responsecompany = await this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', paramscompany, {
          headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() }
        });

        this.firmaBilgileri = {
          Name: credentials.CoperSirketAdi,
          City: responsecompany.body.Il,
          District: responsecompany.body.Ilce,
          CountryCode: "TR",
          Address: responsecompany.body.Adres,
          Gsm: responsecompany.body.Tel,
          Email: responsecompany.body.Email,
          TaxOffice: responsecompany.body.VergiDairesi,
          TaxNo: responsecompany.body.VergiNo
        };
        if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
          this.text1 = this.$t('Company-Email-Or-Tax-Number-Not-Found');
          this.loadingdialog = false;
          this.snackbar = true;
          return false;
        }
        this.loadingdialog = false;
        return true;
      } catch (error) {
        this.text1 = this.$t('Service-Unavailable');
        this.loadingdialog = false;
        this.snackbar = true;
        return false;
      }
    },
    async EkurunGetir() {
      this.loadingdialog = true;
      try {
        const params3 = { GrupID: null, UrunID: null, MusteriID: null };
        const response = await this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList', params3, {
          headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() }
        });

        const ekurun = response.body[3].Aktif;
        if (!ekurun) {
          this.text1 = this.$t('Marketplace-Product-Not-Found');
          this.loadingdialog = false;
          this.snackbar = true;
          return false;
        }
        this.loadingdialog = false;
        return true;
      } catch (error) {
        this.text1 = this.$t('Service-Unavailable');
        this.loadingdialog = false;
        this.snackbar = true;
        return false;
      }
    },
    async chkAgency() {
      this.loadingdialog = true;
      try {
        const params = { Email: this.firmaBilgileri.Email, TaxNo: this.firmaBilgileri.TaxNo };
        const response = await this.$http.post(auth.BOOKING_API_URL + 'Agency/CheckAgency', params, {
          headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() }
        });

        if (response.body.HasError) {
          this.loadingdialog = false;
          return false;
        } else {
          this.loadingdialog = false;
          this.bookingUserName = response.body.Username;
          this.bookingUserPassword = response.body.Password;
          return true;
        }
      } catch (error) {
        this.loadingdialog = false;
        return false;
      }
    },
    async BookingKontrol() {
      this.loadingdialog = true;
      const coperFirmaBilgileri = await this.FirmaBilgileriGetir();
      if (!coperFirmaBilgileri) return;

      const ekUrunVar = await this.EkurunGetir();
      if (!ekUrunVar) return;

      const firmaVar = await this.chkAgency();
      if (!firmaVar) {
        const firmaEklendi = await this.addAgency2();
        if (!firmaEklendi) return;
      }

      if (firmaVar || firmaEklendi) {
        await this.login();
        await this.getProviders();
      }
      this.loadingdialog = false;
    },
    async login() {
      this.loadingdialog = true;
      const params = {
        Username: this.bookingUserName,
        Password: this.bookingUserPassword,
        IsTest: false
      };

      return this.$http
        .post(auth.BOOKING_API_URL + "Login", params, {
          headers: { Authorization: "Bearer " + auth.getAuthHeader() },
        })
        .then(
          (response) => {
            this.SessionId = response.body.SessionId;
            this.SessionToken = response.body.SessionToken;
            window.localStorage.setItem("transferBookingParams", JSON.stringify(response.body));
            this.loadingdialog = false;
            return response;
          },
          (response) => {
            this.text1 = this.$t('Service-Unavailable');
            this.loadingdialog = false;
            this.snackbar = true;
            throw response;
          }
        );
    },
    async getProviders() {
      this.loadingdialog = true;
      this.itemsproviders = [];
      const params = {
        SessionHeader: { SessionId: this.SessionId, SessionToken: this.SessionToken }
      };

      return this.$http
        .post(auth.BOOKING_API_URL + "Agency/GetCredential", params, {
          headers: { Authorization: "Bearer " + auth.getAuthHeader() },
        })
        .then(
          (response) => {
            const rsp = response.body.Credentials || [];
            rsp.forEach(element => {
              if (element.ProviderType === 'Transfer') {
                if (element.OfficeId) this.prmPaxDriveAcenteKod = element.OfficeId;
                this.itemsproviders.push({
                  Id: element.Id,
                  Provider: element.Provider,
                  ProviderType: element.ProviderType,
                  ServiceUsername: element.ServiceUsername,
                  ServicePassword: element.ServicePassword,
                  ServiceSecurityKey: element.ServiceSecurityKey,
                  url: element.Address,
                  OfficeId: element.OfficeId
                });
              }
            });
            this.loadingdialog = false;
            return response;
          },
          (response) => {
            this.text1 = this.$t('Service-Unavailable');
            this.loadingdialog = false;
            this.snackbar = true;
            throw response;
          }
        );
    },
    getImgUrl(pet) {
      return "https://partner.paxdrive.com" + pet;
    },
    irtibatDialog() {
      this.$refs.tanitimdialog.open(0);
    },
    getparabirimi() {
      return "";
    },
    aramakontrol() {
      this.aramaYapildimi = true;
    },
    aramakontrolBirak() {
      this.aramaYapildimiBirak = true;
    },
    yetiskinArttir() {
      this.Azalt = false;
      this.yetiskinSayi++;
    },
    yetiskinAzalt() {
      if (this.yetiskinSayi >= 2) {
        this.yetiskinSayi--;
      } else {
        this.Azalt = true;
      }
    },
    cocukArttir() {
      this.AzaltCocuk = false;
      this.cocukSayi++;
    },
    cocukAzalt() {
      if (this.cocukSayi >= 1) {
        this.cocukSayi--;
      } else {
        this.AzaltCocuk = true;
      }
    },
    bebekArttir() {
      this.AzaltBebek = false;
      this.bebekSayi++;
    },
    bebekAzalt() {
      if (this.bebekSayi >= 1) {
        this.bebekSayi--;
      } else {
        this.AzaltBebek = true;
      }
    },
    idgonder(VehicleId, ResponseId, Rate) {
      if (this.prmPaxDriveAcenteKod == null || this.prmPaxDriveAcenteKod == '') {
        this.text1 = this.$t('Select-Agency-Code-Warning');
        this.loadingdialog = false;
        this.snackbar = true;
        return;
      }
      var ppi = this.GetVehicles.PickupPointId;
      var dpi = this.GetVehicles.DropPointId;

      var alisyeri = this.transferaditems.filter(el => el.value == ppi);
      var birakilisyeri = this.transferbirakaditems.filter(el => el.value == dpi);

      var PickupText = alisyeri.length > 0 ? alisyeri[0].name : null;
      var DropText = birakilisyeri.length > 0 ? birakilisyeri[0].name : null;

      var url =
        "#/coper/paxdrive/transferislem/id?" +
        "vehicleId=" + VehicleId +
        "&responseId=" + ResponseId +
        "&adultCount=" + this.yetiskinSayi +
        "&childCount=" + this.cocukSayi +
        "&babyCount=" + this.bebekSayi +
        "&dateAndTime=" + this.GetVehicles.TransferDateAndTime + " " + this.Time +
        "&markupCurrency=" + Rate +
        "&pickupText=" + PickupText +
        "&dropText=" + DropText +
        "&pickupPointId=" + ppi +
        "&dropPointId=" + dpi +
        "&islemTipi=" + this.islemTipi;

      window.open(url, "_target");
    },
    AlinisYeriCek(val) {
      if (val.length >= 3) {
        this.progress = true;
        var params = {
          Location: val,
          SessionHeader: { SessionId: this.SessionId, SessionToken: this.SessionToken }
        };
        setTimeout(() => {
          this.$http
            .post(auth.BOOKING_API_URL + "Transfer/Location/Search", params, {
              headers: { Authorization: "Basic " + window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS) },
            })
            .then(
              (response) => {
                this.aramaYapildimi = false;
                this.alinisitems = response.body.Locations.sort((a, b) => {
                  const getOrder = (type) => {
                    if (type === 2) return 0;
                    if (type === 1) return 1;
                    return 2;
                  };
                  return getOrder(a.LocType) - getOrder(b.LocType);
                });
                console.log(this.alinisitems, "alinisitems")

                // Artık sıralı olan veriyi döngü ile aktarabiliriz
                for (var i = 0; i < this.alinisitems.length; i++) {
                  this.transferaditems.push({
                    name: this.alinisitems[i].LocName,
                    value: this.alinisitems[i].LocId,
                    deger: this.alinisitems[i].ZoneId,
                    LocType: this.alinisitems[i].LocType
                  });
                }
                this.progress = false;
              },
              (response) => {
                this.text1 = this.$t("An-error-has-occurred-during-location-search");
                this.snackbar = false;
                this.progress = false;
              }
            );
        }, 500);
      }
    },
    BirakilisYeriCek(val) {
      if (val.length >= 3) {
        this.progress = true;
        var params = {
          Location: val,
          SessionHeader: { SessionId: this.SessionId, SessionToken: this.SessionToken }
        };
        setTimeout(() => {
          this.$http
            .post(auth.BOOKING_API_URL + "Transfer/Location/Search", params, {
              headers: { Authorization: "Basic " + window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS) },
            })
            .then(
              (response) => {
                this.aramaYapildimiBirak = false;
                this.birakilisitems = response.body.Locations.sort((a, b) => {
                  const getOrder = (type) => {
                    if (type === 2) return 0;
                    if (type === 1) return 1;
                    return 2;
                  };
                  return getOrder(a.LocType) - getOrder(b.LocType);
                });
                response.body.Locations.forEach((element) => {
                  this.transferbirakaditems.push({
                    name: element.LocName,
                    value: element.LocId,
                    deger: element.ZoneId,
                    LocType: element.LocType // <--- Bunu ekledik
                  });
                });
                this.progress = false;
              },
              (response) => {
                this.text1 = this.$t("An-error-has-occurred-during-location-search");
                this.snackbar = true;
                this.progress = false;
              }
            );
        }, 500);
      }
    },
    TransferAra() {
      if (this.$refs.TransferFiyatGetir.validate()) {
        this.loadingdialog = true;
        var credentials = JSON.parse(window.localStorage.getItem("credentials"));
        var paraBirimi = credentials.ParaBirimi;
        var params = {
          SessionHeader: { SessionId: this.SessionId, SessionToken: this.SessionToken },
          PickupPoint: null,
          DropPoint: null,
          PickupPointId: this.GetVehicles.PickupPointId,
          DropPointId: this.GetVehicles.DropPointId,
          TransferDateAndTime: this.GetVehicles.TransferDateAndTime + " " + this.Time,
          AdtPaxCount: this.yetiskinSayi,
          ChdPaxCount: this.cocukSayi,
          InfPaxCount: this.bebekSayi,
          TransferType: "D",
          MarkupType: this.GetVehicles.MarkupType,
          Markup: this.GetVehicles.Markup,
          Currency: paraBirimi
        };

        this.$http
          .post(auth.BOOKING_API_URL + "transfer/Search", params, {
            headers: { Authorization: "Basic " + window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS) },
          })
          .then(
            (response) => {
              this.transferitems = response.body.Vehicles;
              this.kayitvarmi = true;
              this.loadingdialog = false;
            },
            (response) => {
              this.text1 = this.$t("An-error-has-occurred-while-searching-transfer");
              this.snackbar = true;
              this.loadingdialog = false;
            }
          );
      } else {
        this.text1 = this.$t('Please-fill-in-the-required-fields.');
        this.snackbar = true;
      }
    },
    getMinTransferDate() {
      var today = new Date();
      today.setDate(today.getDate() + 2);
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      return yyyy + '-' + mm + '-' + dd;
    }
  }
};
</script>

<style scoped>
/* Header */
.page-header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 20px 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

/* Cards */
.section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 3px solid transparent;
}

.card-header.purple-bar {
  border-top-color: #667eea;
  background: #fafafa;
}

.card-body {
  padding: 14px 16px 4px;
}

.responsive {
  max-width: 100%;
  height: auto;
}

.transfer-img-frame {
  width: 100%;
  max-width: 160px;
  height: 100px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}
</style>